import { Flex } from '@chakra-ui/react'

import { Skeleton } from '../../components/SkeletonLoader'
import { TAG_LAYOUT, TagLayout } from '../tag/tagLayout'
import { ListLayout, type ListLoadingPreset } from './listLayout'

export const ListRowSkeleton = ({
  preset = 'default',
  count,
}: {
  preset?: ListLoadingPreset
  count?: number
}) => {
  const { listLoadingCount, listGapSize } = ListLayout.resolveListOptions({
    preset,
  })
  const skeletonCount = Math.max(1, count ?? listLoadingCount)
  const gap = ListLayout.gapSize(listGapSize)
  const supplementalSkeletonStyles =
    preset === 'supplementalDrawer'
      ? TagLayout.supplementalSkeletonStyles()
      : null
  const sizeStyles = TagLayout.sizeStyles()

  return (
    <Flex gap={gap} alignItems="center" flexDirection="row">
      {Array.from({ length: skeletonCount }).map((_, index) => (
        <Skeleton
          key={index}
          isLoading
          w={supplementalSkeletonStyles?.width ?? sizeStyles.skeletonWidth}
          h={
            supplementalSkeletonStyles?.height ??
            TagLayout.skeletonHeight(sizeStyles.fontSize)
          }
          rounded={supplementalSkeletonStyles?.rounded ?? TAG_LAYOUT.rounded}
        />
      ))}
    </Flex>
  )
}
